// @flow
import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { isLoggedInTutor } from 'utils/user-auth';

const checkLocalStorage = () => isLoggedInTutor();

const TutorRoute = ({ component: Component, ...rest }: any) => (
  <Route
    {...rest}
    render={props => (checkLocalStorage() ? <Component {...props} /> : <Redirect to="/" />)}
  />
);

export default TutorRoute;



// WEBPACK FOOTER //
// ./src/routes/tutor-route.js